import { useEffect, useLayoutEffect, useState, useRef } from "react";
import { connect, useStore } from "react-redux";
import { useHistory } from "react-router-dom";
import useMedia from "use-media";
import { useRtoaster } from "../../../hooks/useRtoaster";
import { default as commonUtil } from "../../../common/commonUtil";
import { apiKeyCheck, getFacilityInfo, getVacancyList, versionGetApi, getAvailablePlan, getRoomList, getRestaurantVacancyList } from "../../../const";
import Const from "../../../const/Const";
import messageConst from "../../../const/messageConst";
import { GetPublicHoliday } from "../../../hooks/getPublicHoliday";
import img_save from '../../../resources/icons/ico_memo.svg';
import common from "../../../resources/js/common/common";
import { Button } from "../../atoms/button";
import { BreadCrumb } from "../../molecules/breadCrumb";
import ConditionDesignationArea from "../../molecules/conditionDesignationArea";
import { ErrorMassage } from "../../molecules/errorMassage";
import VacancyInfoContainer from "./../hotel/vacancyInfoContainer";
import VacancyInfoContainerCallender from "./../hotel/vacancyInfoContainerCallender";
import { replaceLineBreakCharToLineBreak } from '../../../pages_membership_hotel/hotel/membershipVacancy';
import { Label } from "../../atoms/label";
import { Loading } from "../../molecules/loading";
const MembershipSearchContainer = (props) => {
    const {
        state,
        checkIn,
        checkOut,
        room,
        planConditions,
        grade,
        roomDetailCriteria,
        food,
        privilegedService,
        restaurantInfo,
        membershipFacility,
        membershipSearchParam,
        setRoom,
        setResvKaiinken,
        setCheckIn,
        setCheckOut,
        setPlanConditions,
        setGrade,
        setRoomDetailCriteria,
        setFood,
        setPrivilegedService,
        setMembershipFacility,
        setMembershipSearchParam,
        resvKaiinken,
        setOpenFacilityFlg,
        login,
        adultNum,
        childNum,
        setAdultNum,
        setChildNum,
        overnightFlg,
        setOvernightFlg,
        setMembershipResvStartDate,
        onClickOpenSavedSearchCriteriaWindow,
        onClickOpenCalendarWindow,
        onClickOpenStartTimeWindow,
        onClickOpenCheckListWindow,
        onClickOpenFacilityCalendarWindow,
        onClickOpenRoomDetailPopup,
        onClickOpenRestaurantVacancyPopup,
        setVacancyInfo,
        setDispFacility,
        setSearchVacancyParam,
        setSelectKeiyakuNo,
        onClickOpenMessageWindow,
        setDispDetailCondition,
        setInputUserInfo, } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const [displaySwitch, setDisplaySwitch] = useState(true);
    const [conditionChanged, setConditionChanged] = useState(false);
    const vacancyInfo = state.vacancyInfo;
    const [roomVacancyInfo, setRoomVacancyInfo] = useState([]);
    const [restaurantVacancyInfo, setRestaurantVacancyInfo] = useState([]);
    const [vacancyWeek, setVacancyWeek] = useState([]);
    const [MonthHead, setMonthHead] = useState("");
    const [MonthLast, setMonthLast] = useState("");
    const firstDate = useRef(null);
    const limitDate = useRef(null);

    const [roomNumber, setRoomNumber] = useState("1");
    const [dispAdultNum, setDispAdultNum] = useState("2");
    const [dispChildNum, setDispChildNum] = useState("0");
    const [kaiinkenNumber, setKaiinkenNumber] = useState("1");

    const searchVacancyParam = state.searchVacancyParam;

    const [loadingFlg, setLoadingFlg] = useState(false);

    const { getHoliday } = GetPublicHoliday();

    const [linkList, setLinkList] = useState([]);
    
    const [detailInfo, setDetailInfo] = useState({detailFlg: false, facilityId: "", facilityName: ""});
    const [titleFacilityName, setTitleFacilityName] = useState(false);

    const history = useHistory();
    const store = useStore();

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessage: null, errorFlg: false, });
    const [errFlgList, setErrFlgList] = useState({ errFacility: false, errPeopleNum: false, errAdultNum: false });

    // rtoasterタグ生成
    useRtoaster();

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (state.loginType === 'CRAWL'){
            history.push("/reserve/hotel/crawlLogin");
            return;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    // API呼出等事前処理
    useEffect(() => {
        console.log('store.getState()store.getState()', store.getState())
        console.log('history.location', history.location)
        window.scroll({ top: 0, behavior: 'smooth' })
        if (overnightFlg) {
            setErrorInfo({errorMessage: [messageConst.OVERNIGHT_ERROR], errorFlg: true});
            setMembershipResvStartDate("");
        }
        setLinkList([{ path: "/reserve/top", label: "HOME" }]);
        common.doPost(versionGetApi, {}, afterVerCheck);

        store.dispatch({ type: "DISP_FACILITY", payload: { dispFacility: "選択なし" } });
        store.dispatch({ type: "DISP_DETAIL_CONDITION", payload: { dispDetailCondition: "選択なし" } });

        const now = new Date();
        const iniCheckInDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 3);
        const iniCheckOutDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 4);
        firstDate.current = iniCheckInDate;
        limitDate.current = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate() + 1)

        let keiyakuNo = resvKaiinken.find(val => val.keiyakuDatSort === 1)?.keiyakuNo
        // 空室照会以外からの遷移
        if (!history.location.state || history.location.state.prevRef !== 'vacancy') {
            setCheckIn(iniCheckInDate);
            setCheckOut(iniCheckOutDate);
            getDefaultPullDown();
            setInputUserInfo({});
        } else {
            // 空室照会から遷移した場合
            if (history.location.state.date) {
                // 日付有りなら引継ぎ
                const checkInDate = new Date(history.location.state.date);
                // 翌日
                const checkOutDate = new Date(history.location.state.date);
                checkOutDate.setDate(checkOutDate.getDate() + 1);
                setCheckIn(checkInDate);
                setCheckOut(checkOutDate);
            } else {
                setCheckIn(iniCheckInDate);
                setCheckOut(iniCheckOutDate);
            }
            getDefaultPullDown();
        }

        // 施設・部屋グレード情報取得
        common.doPost(getFacilityInfo, { keiyakuNo: keiyakuNo }, afterGetFacilityInfo);


    }, []);

    const getDefaultPullDown = () => {
        // 人数設定処理
        const adultList = commonUtil.getPeopleNumList(1, 5, 2)
        const childList = commonUtil.getPeopleNumList(0, 4, 0)
        setAdultNum(adultList);
        setChildNum(childList);
        adultList.forEach((data) => {
            if (data.selected === true) setDispAdultNum(data.id);
        });
        childList.forEach((data) => {
            if (data.selected === true) setDispChildNum(data.id);
        });

        // 室数設定処理
        const rooms = [
            { id: "1", value: "1室", selected: true },
            { id: "2", value: "2室", selected: false },
            { id: "3", value: "3室", selected: false }
        ];
        setRoom(rooms);
        rooms.forEach((data) => {
            if (data.selected === true) setRoomNumber(data.id);
        });

        // 会員権情報設定処理
        resvKaiinken.sort((a, b) => a.keiyakuDatSort - b.keiyakuDatSort);
        resvKaiinken.forEach((value, index) => {
            if (index === 0) {
                value.selected = true;
                setKaiinkenNumber(value.id)
            } else {
                value.selected = false;
            }
        })
        setResvKaiinken(resvKaiinken);
    }
    const getRandomIntInclusive = (min, max, type) => {
        min = Math.ceil(min);
        max = Math.floor(max);
        let resultNum = Math.floor(Math.random() * (max - min + 1) + min);
        let result = "";
        if (type === "color") {
            switch (resultNum) {
                case 1:
                    result = "gold";
                    break;
                case 2:
                    result = "red";
                    break;
                case 3:
                    result = "white";
                    break;
                case 4:
                    result = "blue";
                    break;
                default:
                    break;
            }
            return result;
        } else {
            switch (resultNum) {
                case 1:
                    result = "○";
                    break;
                case 2:
                    result = "△";
                    break;
                case 3:
                    result = "□";
                    break;
                case 4:
                    result = "×";
                    break;
                case 5:
                    result = "-";
                    break;
                case 6:
                    result = "/";
                    break;
                case 7:
                    result = "占";
                    break;
                default:
                    break;
            }
            return result;
        }
    }

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    // 施設・部屋グレード情報取得後処理
    const afterGetFacilityInfo = (res) => {
        const data = res.data;
        if (data.resultCode == 0) {
            // 空室照会からの遷移
            if (history.location.state && history.location.state.prevRef === 'vacancy') {

                // レスポンスを画面の持ち方に変換
                let memberHotelList = [];
                data.shisetsuInfo?.memberHotelList && data.shisetsuInfo.memberHotelList.forEach(main => {
                    let list = [];
                    main.shisetsuList.forEach(membership => {
                        let membershipObj = { class: "facility", id: membership.shisetsuCd, value: membership.shisetsuName, checked: false, disabled: !membership.enable, openFlg: membership.openFlg, openingDate: membership.openingDate }
                        list.push(membershipObj);
                    })
                    let mainBuildingObj =
                    {
                        mainGroupCd: main.mainGroupCd,
                        mainGroupName: main.mainGroupName,
                        checked: false,
                        displayFlg: false,
                        disabled: main.honkanShisetsuRiyoFlg,
                        shisetsuList: list
                    };
                    memberHotelList.push(mainBuildingObj);
                    resvKaiinken.forEach(info => {
                        if (info.selected) {
                            const selectedFacility = list.find(facility => facility.id == info.sisetuCd);
                            if (selectedFacility) {
                                setOpenFacilityFlg(selectedFacility.openFlg);
                            }
                        }
                    })
                })
                let generalHotelList = [];
                data.shisetsuInfo?.generalHotelList && data.shisetsuInfo.generalHotelList.forEach(main => {
                    let list = [];
                    main.shisetsuList.forEach(ippan => {
                        let ippanObj = { class: "facility", id: ippan.shisetsuCd, value: ippan.shisetsuName, checked: false, disabled: !ippan.enable }
                        list.push(ippanObj);
                    })
                    let mainBuildingObj =
                    {
                        mainGroupCd: main.mainGroupCd,
                        mainGroupName: main.mainGroupName,
                        checked: false,
                        displayFlg: false,
                        disabled: false,
                        shisetsuList: list
                    };
                    generalHotelList.push(mainBuildingObj);
                })
                // 空室照会にて施設選択〇△を押下した施設のみチェックした状態にする
                // 空室照会にて施設選択〇△を押下した施設
                const targetShisetsuCd = history.location.state.shisetsuCd;


                [...memberHotelList, ...generalHotelList].forEach(group => {
                    group.shisetsuList.forEach(shisetsu => {
                        if (targetShisetsuCd === shisetsu.id) {
                            // 対象施設をチェック、グループ表示
                            // 先頭の会員券に該当しない
                            if (shisetsu.disabled) {
                                onClickOpenMessageWindow(messageConst.REQUIRE_KAIINKEN_ERROR);
                            } else {
                                // グループOpen
                                group.displayFlg = true;
                                // 施設選択
                                shisetsu.checked = true;
                                // 表示ラベル設定
                                setDispFacility(shisetsu.value);

                            }
                        }
                    });
                    // グループ選択状態更新
                    // enabledあり、且つenabledの未選択が無い場合チェック
                    group.checked = group.shisetsuList.some(value => value.disabled === false)
                        && !group.shisetsuList.some(value => value.disabled === false && value.checked === false);

                })
                // 施設選択情報
                setMembershipFacility({ membership: memberHotelList, ippan: generalHotelList })
                getInitConditions(data)
            } else {
                let memberHotelList = [];
                data.shisetsuInfo?.memberHotelList && data.shisetsuInfo.memberHotelList.forEach(main => {
                    let list = [];
                    main.shisetsuList.forEach(membership => {
                        let membershipObj = { class: "facility", id: membership.shisetsuCd, value: membership.shisetsuName, checked: false, disabled: !membership.enable, openFlg: membership.openFlg, openingDate: membership.openingDate }
                        list.push(membershipObj);
                    })
                    let mainBuildingObj =
                    {
                        mainGroupCd: main.mainGroupCd,
                        mainGroupName: main.mainGroupName,
                        checked: false,
                        displayFlg: false,
                        disabled: main.honkanShisetsuRiyoFlg,
                        shisetsuList: list
                    };
                    memberHotelList.push(mainBuildingObj);
                    resvKaiinken.forEach(info => {
                        if (info.selected) {
                            const selectedFacility = list.find(facility => facility.id == info.sisetuCd);
                            if (selectedFacility) {
                                setOpenFacilityFlg(selectedFacility.openFlg);
                            }
                        }
                    })
                })
                let generalHotelList = [];
                data.shisetsuInfo?.generalHotelList && data.shisetsuInfo.generalHotelList.forEach(main => {
                    let list = [];
                    main.shisetsuList.forEach(ippan => {
                        let ippanObj = { class: "facility", id: ippan.shisetsuCd, value: ippan.shisetsuName, checked: false, disabled: !ippan.enable }
                        list.push(ippanObj);
                    })
                    let mainBuildingObj =
                    {
                        mainGroupCd: main.mainGroupCd,
                        mainGroupName: main.mainGroupName,
                        checked: false,
                        displayFlg: false,
                        disabled: false,
                        shisetsuList: list
                    };
                    generalHotelList.push(mainBuildingObj);
                })
                setMembershipFacility({ membership: memberHotelList, ippan: generalHotelList })
                getInitConditions(data);
            }
        }
    }

    const getInitConditions = (data) => {
        let grades = [];
        data.roomGradeList && data.roomGradeList.forEach(value => {
            let item = { class: "gradeList", id: value.gradeCd, value: value.gradeName, checked: false, disabled: !value.enable }
            grades.push(item);
        })
        setGrade(grades);

        let planConditionsList = [];
        data.planConditionsList && data.planConditionsList.forEach(value => {
            let item = { class: "planConditions", id: value.planConditionsCd, value: value.planConditionsName, checked: false, disabled: !value.enable }
            planConditionsList.push(item);
        })
        setPlanConditions(planConditionsList);

        let foodList = [];
        data.foodList && data.foodList.forEach(value => {
            let item = { class: "foodList", id: value.foodCd, value: value.foodName, checked: false, disabled: !value.enable }
            foodList.push(item);
        })
        setFood(foodList);

        let privilegedServiceList = [];
        data.privilegedServiceList && data.privilegedServiceList.forEach(value => {
            let item = { class: "privilegedService", id: value.privilegedServiceCd, value: value.privilegedServiceName, checked: false, disabled: false, description: value.privilegedServiceText }
            privilegedServiceList.push(item);
        })
        setPrivilegedService(privilegedServiceList);

        let roomDetailCriterias = [];
        data.roomConditionsList && data.roomConditionsList.forEach(value => {
            let item = { class: "gradeList", id: value.roomConditionCd, value: value.roomConditionName, checked: false }
            roomDetailCriterias.push(item);
        })
        setRoomDetailCriteria(roomDetailCriterias);
    }

    const getPopUpCheckedInfo = (data) => {
        let memberHotelList = [];
        data.shisetsuInfo?.memberHotelList && data.shisetsuInfo.memberHotelList.forEach(main => {
            let list = [];
            main.shisetsuList.forEach(membership => {
                let membershipObj = {};
                if (membership.enable && membershipFacility.membership.find(m => m.mainGroupCd === main.mainGroupCd).shisetsuList.find(s => s.id === membership.shisetsuCd).checked) {
                    membershipObj = { class: "facility", id: membership.shisetsuCd, value: membership.shisetsuName, checked: true, disabled: !membership.enable, openFlg: membership.openFlg, openingDate: membership.openingDate }
                } else {
                    membershipObj = { class: "facility", id: membership.shisetsuCd, value: membership.shisetsuName, checked: false, disabled: !membership.enable, openFlg: membership.openFlg, openingDate: membership.openingDate }
                }
                list.push(membershipObj);
            })
            let mainBuildingObj =
            {
                mainGroupCd: main.mainGroupCd,
                mainGroupName: main.mainGroupName,
                checked: list.some(membership => membership.disabled === false) && !list.some(membership => membership.disabled === false && membership.checked === false),
                displayFlg: false,
                disabled: main.honkanShisetsuRiyoFlg,
                shisetsuList: list
            };
            memberHotelList.push(mainBuildingObj);
        })

        let generalHotelList = [];
        data.shisetsuInfo?.generalHotelList && data.shisetsuInfo.generalHotelList.forEach(main => {
            let list = [];
            main.shisetsuList.forEach(ippan => {
                let ippanObj = {}
                if (ippan.enable && membershipFacility.ippan.find(i => i.mainGroupCd === main.mainGroupCd).shisetsuList.find(s => s.id === ippan.shisetsuCd).checked) {
                    ippanObj = { class: "facility", id: ippan.shisetsuCd, value: ippan.shisetsuName, checked: true, disabled: !ippan.enable }
                } else {
                    ippanObj = { class: "facility", id: ippan.shisetsuCd, value: ippan.shisetsuName, checked: false, disabled: !ippan.enable }
                }
                list.push(ippanObj);
            })
            let mainBuildingObj =
            {
                mainGroupCd: main.mainGroupCd,
                mainGroupName: main.mainGroupName,
                checked: list.some(ippan => ippan.disabled === false) && !list.some(ippan => ippan.disabled === false && ippan.checked === false),
                displayFlg: false,
                disabled: false,
                shisetsuList: list
            };
            generalHotelList.push(mainBuildingObj);
        })
        setMembershipFacility({ membership: memberHotelList, ippan: generalHotelList });
        let dispText = "";
        memberHotelList.forEach(group => {
            group.shisetsuList.forEach(item => {
                if (item.checked) {
                    dispText = dispText + (dispText == "" ? "" : ", ");
                    dispText = dispText + item.value;
                }
            })
        })
        generalHotelList.forEach(group => {
            group.shisetsuList.forEach(item => {
                if (item.checked) {
                    dispText = dispText + (dispText == "" ? "" : ", ");
                    dispText = dispText + item.value;
                }
            })
        })
        setDispFacility(dispText);

        let planConditionsList = [];
        data.planConditionsList.forEach(value => {
            let item = {};
            if (value.enable && planConditions.find(p => p.id === value.planConditionsCd).checked) {
                item = { class: "planConditions", id: value.planConditionsCd, value: value.planConditionsName, checked: true, disabled: !value.enable }
            } else {
                item = { class: "planConditions", id: value.planConditionsCd, value: value.planConditionsName, checked: false, disabled: !value.enable }
            }
            planConditionsList.push(item);
        })
        setPlanConditions(planConditionsList);

        let foodList = [];
        data.foodList.forEach(value => {
            let item = {};
            if (value.enable && food.find(f => f.id === value.foodCd).checked) {
                item = { class: "foodList", id: value.foodCd, value: value.foodName, checked: true, disabled: !value.enable }
            } else {
                item = { class: "foodList", id: value.foodCd, value: value.foodName, checked: false, disabled: !value.enable }
            }
            foodList.push(item);
        })
        setFood(foodList);

        let privilegedServiceList = [];
        data.privilegedServiceList.forEach(value => {
            let item = {};
            if (privilegedService.find(p => p.id === value.privilegedServiceCd).checked) {
                item = { class: "privilegedService", id: value.privilegedServiceCd, value: value.privilegedServiceName, checked: true, disabled: false, description: value.privilegedServiceText }
            } else {
                item = { class: "privilegedService", id: value.privilegedServiceCd, value: value.privilegedServiceName, checked: false, disabled: false, description: value.privilegedServiceText }
            }
            privilegedServiceList.push(item);
        })
        setPrivilegedService(privilegedServiceList);

        let dispText2 = "";
        planConditionsList.forEach(item => {
            if (item.checked) {
                dispText2 = dispText2 + (dispText2 == "" ? "" : ", ");
                dispText2 = dispText2 + item.value;
            }
        })
        foodList.forEach(item => {
            if (item.checked) {
                dispText2 = dispText2 + (dispText2 == "" ? "" : ", ");
                dispText2 = dispText2 + item.value;
            }
        })
        privilegedServiceList.forEach(item => {
            if (item.checked) {
                dispText2 = dispText2 + (dispText2 == "" ? "" : ", ");
                dispText2 = dispText2 + item.value;
            }
        })
        setDispDetailCondition(dispText2);
    }

    // 検索ボタン押下時
    const onClickSearch = () => {
        setOvernightFlg(false);
        // バリデーションフラグ
        let errFlg = false;
        let errorMessage = [];
        let flgList = { errFacility: false, errPeopleNum: false, errAdultNum: false };

        // チェックイン
        const startDate = commonUtil.getStringFromDate(new Date(checkIn), "yyyy-MM-dd");
        // チェックアウト
        const endDate = commonUtil.getStringFromDate(new Date(checkOut), "yyyy-MM-dd");
        // 室数
        let vacancyNum = 1;
        room.forEach((data) => {
            if (data.selected === true) vacancyNum = parseInt(data.id);
        });

        // 会員権
        let keiyakuNo = "";
        let kaiinkenCd = "";
        let kaiinkenNo = "";
        let riyoKaiinkenSyubetCd = "";
        let targetShisetsuCd = "";

        resvKaiinken.forEach((data) => {
            if (data.selected === true) {
                keiyakuNo = data.keiyakuNo;
                kaiinkenCd = data.id;
                kaiinkenNo = data.value;
                riyoKaiinkenSyubetCd = data.riyoKaiinkenSyubetCd;
                targetShisetsuCd = data.sisetuCd;
            }
        });

        // 施設
        let facilityArray = [];
        let openingDate = "";
        membershipFacility.membership.forEach((data) => {
            if (data.shisetsuList) {
                data.shisetsuList.forEach(item => {
                    if (item.checked) facilityArray.push(item.id);
                    if (item.id == targetShisetsuCd && item.openingDate) {
                        openingDate = item.openingDate;
                    }
                })
            }
        });
        membershipFacility.ippan.forEach((data) => {
            if (data.shisetsuList) {
                data.shisetsuList.forEach(item => {
                    if (item.checked) facilityArray.push(item.id);
                })
            }
        });
        if (facilityArray.length === 0) {
            membershipFacility.membership.forEach((data) => {
                if (data.shisetsuList) {
                    data.shisetsuList.forEach(item => {
                        if (!item.disabled) facilityArray.push(item.id);
                    })
                }
            });
            membershipFacility.ippan.forEach((data) => {
                if (data.shisetsuList) {
                    data.shisetsuList.forEach(item => {
                        if (!item.disabled) facilityArray.push(item.id);
                    })
                }
            });
        }
        if (openingDate != "" && commonUtil.checkOpeningDate(startDate, endDate, openingDate)) {
            errorMessage.push(messageConst.OPENING_DATE_ERROR);
            errFlg = true;
        }

        // 1室あたりの人数
        let adults = 2;
        adultNum.forEach((data) => {
            if (data.selected === true) adults = parseInt(data.id);
        });
        let children = 0;
        childNum.forEach((data) => {
            if (data.selected === true) children = parseInt(data.id);
        });
        if (adults + children > Const.MAX_ROOM_CAPACITY) {
            errorMessage.push(messageConst.PEOPLE_NUM_ERROR);
            errFlg = true;
            flgList.errPeopleNum = true;
        }
        // if (adults < vacancyNum) {
        //     errorMessage.push(messageConst.ADULT_NUM_ERROR);
        //     errFlg = true;
        //     flgList.errAdultNum = true;
        // }

        // // グレード
        // let gradeArray = [];
        // grade.forEach((data) => {
        //     if (data.checked === true) gradeArray.push(data.id);
        // });

        // プラン条件
        let planConditionsArray = [];
        planConditions.forEach((data) => {
            if (data.checked === true) planConditionsArray.push(data.id);
        });

        // 夕食
        let foodArray = [];
        food.forEach((data) => {
            if (data.checked === true) foodArray.push(data.id);
        });

        // サービス権利
        let privilegedServiceArray = [];
        privilegedService.forEach((data) => {
            if (data.checked === true) privilegedServiceArray.push(data.id);
        });

        setErrFlgList(flgList);
        if (errFlg) {
            window.scroll({ top: 0, behavior: 'smooth' })
            setErrorInfo({ errorMessage: errorMessage, errorFlg: true, });
        } else {
            const params = {
                checkInDate: startDate,
                checkOutDate: endDate,
                nights: commonUtil.getNights(startDate, endDate, "-"),
                shisetsuCdList: facilityArray,
                adultCnt: adults,
                childCnt: children,
                roomCnt: vacancyNum,
                keiyakuNo: keiyakuNo,
                planConditionsCdList: planConditionsArray,
                roomGradeCdList: [],
                foodCdList: foodArray,
                privilegedServiceCdList: privilegedServiceArray,
                kaiinkenCd: kaiinkenCd,
                kaiinkenNo: kaiinkenNo,
                riyoKaiinkenSyubetCd: riyoKaiinkenSyubetCd,
            }
            // 検索条件設定
            setMembershipSearchParam(params);
            setErrorInfo({ errorMessage: null, errorFlg: false, });
            setLoadingFlg(true);
            common.doPost(getAvailablePlan, params, afterGetAvailablePlan);
        }
    }

    // プラン検索結果取得後処理
    const afterGetAvailablePlan = (res) => {
        const data = res.data;
        // エラーが発生した場合はメッセージを表示
        let errMsg = null;
        if (data.resultCode != "0") {
            errMsg = messageConst.SEARCH_ERROR;
        }
        if (data.resultCode == "0" && (!data.shisetsuList || !data.shisetsuList.length)) {
            errMsg = messageConst.HOTEL_PLAN_NOT_FOUND_ERROR;
        }
        if (errMsg) {
            window.scroll({ top: 0, behavior: 'smooth' })
            setErrorInfo({ errorMessage: [errMsg], errorFlg: true, });
            setLoadingFlg(false);
            return;
        }
        // 検索結果が1件以上取得できた場合、検索結果画面に遷移
        setLoadingFlg(false);
        history.push("/reserve/hotel/searchResult");
    }

    // 検索方法変更
    const changeDisplaySwitch = (flg) => {
        setDispDetailCondition("");
        setGrade(grade.map(g => { return { ...g, checked: false } }));
        setRoomDetailCriteria(roomDetailCriteria.map(r => { return { ...r, checked: false } }));
        setPlanConditions(planConditions.map(p => { return { ...p, checked: false } }));
        setFood(food.map(f => { return { ...f, checked: false } }));
        setPrivilegedService(privilegedService.map(p => { return { ...p, checked: false } }));

        setDisplaySwitch(flg);
    }

    // カレンダー検索用検索情報取得
    const runGetVacancyList = (req) => {
        setSearchVacancyParam(req);
        setLoadingFlg(true);
        common.doPostRef(getVacancyList, req, req, afterGetVacancyList);
    }

    // カレンダー空室情報移動
    const onClickMoveWeeks = (type, mobile) => {
        let newDate = commonUtil.getDateFromString(searchVacancyParam.startDate, "-");
        if (type === "back") {
            if (mobile) {
                newDate.setDate(newDate.getDate() - 7);
            } else {
                newDate.setDate(newDate.getDate() - 14);
            }
        } else {
            if (mobile) {
                newDate.setDate(newDate.getDate() + 7);
            } else {
                newDate.setDate(newDate.getDate() + 14);
            }
        }
        let nextYearDate = new Date();
        nextYearDate.setFullYear(nextYearDate.getFullYear() + 1);
        if (newDate >= firstDate.current && newDate <= nextYearDate) {
            let req = {
                keiyakuNo: searchVacancyParam.keiyakuNo,
                kaiinkenCd: searchVacancyParam.kaiinkenCd,
                kaiinkenNo: searchVacancyParam.kaiinkenNo,
                roomGradeList: searchVacancyParam.roomGradeList,
                startDate: commonUtil.getStringFromDate(newDate, "yyyy-MM-dd"),
                nightsNumber: searchVacancyParam.nightsNumber,
                shisetsuCdList: searchVacancyParam.shisetsuCdList,
                roomCnt: searchVacancyParam.roomCnt,
                guestCnt: searchVacancyParam.guestCnt,
                adults: searchVacancyParam.adults,
                children: searchVacancyParam.children,
                riyoKaiinKenSbtKbn: searchVacancyParam.riyoKaiinKenSbtKbn,
                roomConditionCdList: searchVacancyParam.roomConditionCdList
            }
            // カレンダー検索用検索情報取得
            runGetVacancyList(req);
        }
    }

    const getCalendarStartDate = () => {
        return commonUtil.getDateFromString(searchVacancyParam.startDate, "-");
    }

    // カレンダー検索用検索情報取得後処理
    const afterGetVacancyList = (res, refParam) => {
        const data = res.data;
        if (data.resultCode == 0) {
             // 検索基準の日付を設定
             const startDate = new Date(data.startDate);

             let kushitsuList = [];
             data.kushitsuList.forEach(value => {
                 kushitsuList.push({
                     facilityId: value.shisetsuCd,
                     facilityName: isMobilePhone ? replaceLineBreakCharToLineBreak(value.webNameSp) : replaceLineBreakCharToLineBreak(value.webNamePc),
                     titleFacilityName: value.shisetsuName, 
                     honkanShisetsuCd: value.honkanShisetsuCd,
                     vacancyDateList: value.kushitsuDateList,
                     kushitsuSuList: value.kushitsuSuList
                 })
             })
             setVacancyInfo(kushitsuList);
             if (detailInfo.detailFlg) {
                 let targetKushitsuInfo = kushitsuList.find(value => value.facilityId == detailInfo.facilityId);
                 let targetKushitsuSuList = targetKushitsuInfo?.kushitsuSuList;
                 let newRoomVacancyInfo = [];
                 if (targetKushitsuSuList?.length) {
                     // レストラン空き情報取得リクエスト
                     const restaurantReq = {
                         keiyakuNo: refParam.keiyakuNo,
                         startDate: commonUtil.getStringFromDate(startDate, "yyyy-MM-dd"),
                         honkanShisetsuCd: targetKushitsuInfo.honkanShisetsuCd,
                         riyoNinzu: refParam.guestCnt
                     }
                     const roomList = targetKushitsuSuList.filter(value => value.riyoDate == commonUtil.getStringFromDate(startDate, "yyyy-MM-dd"));
                     roomList.forEach(room => {
                         let newObj = {
                             facilityId: detailInfo.facilityId,
                             roomType: room.roomType,
                             roomTypeNam: room.roomTypeNam,
                             grade: room.grade,
                             vacancyDateList: targetKushitsuSuList.filter(value => value.roomType == room.roomType && value.grade == room.grade)
                         }
                         newRoomVacancyInfo.push(newObj);
                     })
                     const ref = {
                         facilityId: detailInfo.facilityId,
                         facilityName: detailInfo.facilityName,
                         roomVacancyInfo: newRoomVacancyInfo,
                         startDate: startDate,
                         restaurantReq: restaurantReq
                     }
                     // 部屋詳細情報取得
                     const roomReq = {
                         keiyakuNo: refParam.keiyakuNo,
                         honkanShisetsuCd: targetKushitsuInfo.honkanShisetsuCd,
                         riyoKaiinkenSyubetCd: refParam.riyoKaiinKenSbtKbn,
                         shisetsuCd: detailInfo.facilityId,
                         riyoDate: refParam.startDate,
                         hakuCnt: 1
                     }
                     common.doPostRef(getRoomList, roomReq, ref, afterGetRoomList);
                 } else {
                     // 2週間分の日付情報
                     let twoWeeks = getWeekList(startDate);
                     getYearMonth(twoWeeks, startDate);
                     setDetailInfo({ detailFlg: false, facilityId: "", facilityName: "" });
                     setLoadingFlg(false);
                 }
             } else {
                 // 2週間分の日付情報
                 let twoWeeks = getWeekList(startDate);
                 getYearMonth(twoWeeks, startDate);
                 setDetailInfo({ detailFlg: false, facilityId: "", facilityName: "" });
                 setLoadingFlg(false);
             }
             document.getElementById("searchFacilityResult").scrollIntoView({ behavior: "smooth" });
         }
    }

    // 詳細リンク押下時
    const onClickDetail = (facilityId, facilityName) => {
        setLoadingFlg(true);
        let targetKushitsuInfo = vacancyInfo.find(value => value.facilityId == facilityId);
        let targetKushitsuSuList = targetKushitsuInfo?.kushitsuSuList;
        let newRoomVacancyInfo = [];
        const startDate = commonUtil.getStringFromDate(vacancyWeek[0].date, "yyyy-MM-dd");
        const roomList = targetKushitsuSuList.filter(value => value.riyoDate == startDate);
        roomList.forEach(room => {
            let newObj = {
                facilityId: facilityId,
                roomType: room.roomType,
                roomTypeNam: room.roomTypeNam,
                grade: room.grade,
                roomDetailInfo: {},
                vacancyDateList: targetKushitsuSuList.filter(value => value.roomType == room.roomType && value.grade == room.grade)
            }
            newRoomVacancyInfo.push(newObj);
        })
        // レストラン空き情報取得リクエスト
        const restaurantReq = {
            keiyakuNo: searchVacancyParam.keiyakuNo,
            startDate: startDate,
            honkanShisetsuCd: targetKushitsuInfo.honkanShisetsuCd,
            riyoNinzu: searchVacancyParam.guestCnt
        }
        const ref = {
            facilityId: facilityId,
            facilityName: facilityName,
            roomVacancyInfo: newRoomVacancyInfo,
            restaurantReq: restaurantReq
        }

        // 部屋詳細情報取得
        const roomReq = {
            keiyakuNo: searchVacancyParam.keiyakuNo,
            honkanShisetsuCd: targetKushitsuInfo.honkanShisetsuCd,
            riyoKaiinkenSyubetCd: searchVacancyParam.riyoKaiinKenSbtKbn,
            shisetsuCd: facilityId,
            riyoDate: searchVacancyParam.startDate,
            hakuCnt: 1
        }
        common.doPostRef(getRoomList, roomReq, ref, afterGetRoomList);

        setTitleFacilityName(facilityName)
    }

    const afterGetRoomList = (res, ref) => {
        let data = res.data;
        if (data.resultCode == 0) {
            let newRoomVacancyInfo = ref.roomVacancyInfo;
            newRoomVacancyInfo.forEach((room, index) => {
                const roomDetailInfo = data.roomList?.find(roomInfo => roomInfo.roomTypeCd == room.roomType);
                if (roomDetailInfo) {
                    room.roomDetailInfo = roomDetailInfo
                }
            });
        }
        common.doPostRef(getRestaurantVacancyList, ref.restaurantReq, ref, afterGetRestaurantVacancyList);
    }

    // レストラン空き情報取得後処理
    const afterGetRestaurantVacancyList = (res, ref) => {
        const data = res.data;
        if (data.resultCode == 0) {
            let restaurantList = data.restaurantList;
            restaurantList.sort((a, b) => (a.jikantai == "夕食" ? 1 : 2) - (b.jikantai == "夕食" ? 1 : 2))
            let newRestaurantVacancyInfo = [];
            restaurantList.forEach(restaurant => {
                let newObj = {
                    facilityId: ref.facilityId,
                    restaurantCd: restaurant.restaurantCd,
                    restaurantName: restaurant.restaurantName,
                    jikantai: restaurant.jikantai,
                    restaurantSetsumei: restaurant.restaurantSetsumei,
                    vacancyDateList: restaurant.restaurantKusekiList
                }
                newRestaurantVacancyInfo.push(newObj);
            })
            setDetailInfo({ detailFlg: true, facilityId: ref.facilityId, facilityName: ref.facilityName });
            setRoomVacancyInfo(ref.roomVacancyInfo);
            setRestaurantVacancyInfo(newRestaurantVacancyInfo);
            if (ref.startDate) {
                // 2週間分の日付情報
                let twoWeeks = getWeekList(ref.startDate);
                getYearMonth(twoWeeks, ref.startDate);
            }
        } else {

        }
        setLoadingFlg(false);
    }

    // 施設一覧に戻るリンク押下時
    const onClickBackFacilityList = () => {
        setDetailInfo({ detailFlg: false, facilityId: "", facilityName: "" });
    }

    // 2週間分の日付情報
    const getWeekList = (nextDate) => {
        console.log(nextDate);
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const array = [];
        for (let i = 0; i < 14; i++) {
            const date = new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate() + i);

            let color = "";
            switch (date.getDay()) {
                case 0:
                    color = "red";
                    break;
                case 6:
                    color = "blue";
                    break;
                default:
                    color = "black";
                    break;
            }

            // 祝日は赤色に変更
            let holiday = getHoliday(date, date, "month");
            if (holiday === "react-calendar__tile_holiday") {
                color = "red";
            }

            const week = {
                day: date.getDate().toString(),
                month: date.getMonth(),
                week: youbi[date.getDay()],
                color: color,
                date: date,
            }
            array.push(week);
        }
        setVacancyWeek(array);
        return array;
    }

    // カレンダーの年月の表示
    const getYearMonth = (twoWeeks, baseDate) => {
        const startDate = new Date(baseDate);
        const yr = startDate.getFullYear();
        const mHead = twoWeeks[0].month
        const mLast = twoWeeks[13].month

        if ((!isMobilePhone && twoWeeks[0].month === twoWeeks[13].month) || (isMobilePhone && twoWeeks[0].month === twoWeeks[6].month)) {
            setMonthHead(<p><span style={isMobilePhone ? style.yearStyleMobile : style.yearStyle}>{yr}年</span><span style={isMobilePhone ? style.monthStyleMobile : style.monthStyle}>{mHead + 1}月</span></p>);
        } else {
            setMonthHead(<p><span style={isMobilePhone ? style.yearStyleMobile : style.yearStyle}>{yr}年</span><span style={isMobilePhone ? style.monthStyleMobile : style.monthStyle}>{mHead + 1}月 ~ {mLast + 1}月</span></p>);
        }
    }

    return (
        <div style={style.top}>
            {loadingFlg ?
                <Loading
                    width={50}
                    height={50}
                    type={"spin"}
                    color={"white"}
                    wrapperClass="crawlSearch_loading"
                /> : null
            }
            <div style={style.tabnavi}>
                <Label
                    label={"※" + messageConst.CHANGE_LIMIT_ERROR}
                    className="membership_vacancy_acc_info_2" 
                />
            </div>
            <div style={isMobilePhone ? style.tabnaviMobile : style.tabnavi2}>
                <Button buttonText={"空室情報から探す"} onClick={() => changeDisplaySwitch(true)} className={displaySwitch ? (isMobilePhone ? "membershipTabStyle2Mobile" : "membershipTabStyle2") : (isMobilePhone ? "membershipTabStyleMobile" : "membershipTabStyle")} />
                <Button buttonText={"条件を指定して探す"} onClick={() => changeDisplaySwitch(false)} className={displaySwitch ? (isMobilePhone ? "membershipTabStyleMobile" : "membershipTabStyle") : (isMobilePhone ? "membershipTabStyle2Mobile" : "membershipTabStyle2")} />
            </div>
            <BreadCrumb
                breadCrumbStyle={isWideTablet ? { display: "none" } : style.breadCrumb}
                linkStyle={style.link}
                linkList={linkList}
                lastLabel="ホテル予約"
                lastLabelClassName="lastLabel"
            />
            <div style={isMobilePhone ? style.wrapperMobile : style.wrapper}>
                {displaySwitch ?
                    <div id="callender" style={displaySwitch ? { display: "block" } : { display: "none" }}>
                        <div style={isMobilePhone ? style.searchboxMobile : style.searchbox}>
                            <VacancyInfoContainer
                                state={state}
                                onClickCheckIn={onClickOpenCalendarWindow}
                                onClickOpenStartTimeWindow={onClickOpenStartTimeWindow}
                                conditionChanged={conditionChanged}
                                setConditionChanged={setConditionChanged}
                                kaiinkenNumber={kaiinkenNumber}
                                setKaiinkenNumber={setKaiinkenNumber}
                                roomNumber={roomNumber}
                                setRoomNumber={setRoomNumber}
                                dispAdultNum={dispAdultNum}
                                setDispAdultNum={setDispAdultNum}
                                dispChildNum={dispChildNum}
                                setDispChildNum={setDispChildNum}
                                setVacancyInfo={setVacancyInfo}
                                setVacancyWeek={setVacancyWeek}
                                setMonthHead={setMonthHead}
                                setMonthLast={setMonthLast}
                                limitDate={limitDate.current}
                                onClickOpenCheckListWindow={onClickOpenCheckListWindow}
                                runGetVacancyList={runGetVacancyList}
                                setSelectKeiyakuNo={setSelectKeiyakuNo}
                                searchVacancyParam={searchVacancyParam}
                                setOpenFacilityFlg={setOpenFacilityFlg}
                                setSearchVacancyParam={setSearchVacancyParam} />
                        </div>
                        <div style={isMobilePhone ? style.searchboxMobile2 : style.searchbox}>
                            <VacancyInfoContainerCallender
                                onClickPlay={onClickOpenCalendarWindow}
                                onClickOpenStartTimeWindow={onClickOpenStartTimeWindow}
                                onClickOpenFacilityCalendarWindow={onClickOpenFacilityCalendarWindow}
                                vacancyInfo={vacancyInfo}
                                roomVacancyInfo={roomVacancyInfo}
                                restaurantVacancyInfo={restaurantVacancyInfo}
                                vacancyWeek={vacancyWeek}
                                MonthHead={MonthHead}
                                MonthLast={MonthLast}
                                firstDate={firstDate.current}
                                titleFacilityName={titleFacilityName}
                                detailFlg={detailInfo.detailFlg}
                                searchVacancyParam={searchVacancyParam}
                                onClickDetail={onClickDetail}
                                onClickBackFacilityList={onClickBackFacilityList}
                                onClickMoveWeeks={onClickMoveWeeks}
                                onClickOpenRoomDetailPopup={onClickOpenRoomDetailPopup}
                                onClickOpenRestaurantVacancyPopup={onClickOpenRestaurantVacancyPopup}
                                getCalendarStartDate={getCalendarStartDate} />
                        </div>
                    </div>
                    :
                    <div id="condition" style={displaySwitch ? { display: "none" } : { display: "block" }}>
                        <div style={isMobilePhone ? style.searchboxMobile : style.searchbox}>
                            <div style={errorInfo.errorFlg ? style.errorDiv : { display: "none" }}>
                                <ErrorMassage style={style.errorMassage} data={errorInfo.errorMessage} />
                            </div>
                            <div style={style.titleArea}>
                                {isMobilePhone ? (<>
                                    <h5>条件を指定して探す</h5>
                                    <h6 style={style.keepLink} onClick={() => onClickOpenSavedSearchCriteriaWindow("savedSearch", login.memberCode)}>　&nbsp;保存した検索条件</h6>
                                </>) : (<>
                                    <h3>条件を指定して探す</h3>
                                    <h4 style={style.keepLink} onClick={() => onClickOpenSavedSearchCriteriaWindow("savedSearch", login.memberCode)}>　&nbsp;保存した検索条件</h4>
                                </>)}
                            </div>
                            <ConditionDesignationArea
                                style={style}
                                state={state}
                                isMobilePhone={isMobilePhone}
                                onClickOpenCalendarWindow={onClickOpenCalendarWindow}
                                onClickOpenCheckListWindow={onClickOpenCheckListWindow}
                                displaySwitch={displaySwitch}
                                conditionChanged={conditionChanged}
                                setConditionChanged={setConditionChanged}
                                getPopUpCheckedInfo={getPopUpCheckedInfo}
                                errFlgList={errFlgList}
                                kaiinkenNumber={kaiinkenNumber}
                                setKaiinkenNumber={setKaiinkenNumber}
                                roomNumber={roomNumber}
                                setRoomNumber={setRoomNumber}
                                dispAdultNum={dispAdultNum}
                                setDispAdultNum={setDispAdultNum}
                                dispChildNum={dispChildNum}
                                setDispChildNum={setDispChildNum}
                                setSelectKeiyakuNo={setSelectKeiyakuNo}
                                setOpenFacilityFlg={setOpenFacilityFlg}
                            />
                        </div>
                        <div style={isMobilePhone ? style.searchboxMobile : style.searchbox}>
                            <Button buttonText="検 索" className={isMobilePhone ? "searchBtnStyleSp" : "searchBtnStylePc"} onClick={onClickSearch} />
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

const style = {
    top: {
        //paddingBottom: "50px",
    },

    wrapper: {
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        textAlign: "center",
        width: "60%",
        margin: "50px auto",
        paddingBottom: "50px",
        fontSize: "80%",
    },
    wrapperMobile: {
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        textAlign: "center",
        width: "93%",
        margin: "auto",
        marginTop: "40px",
        padding: "0px 10px 20px",
        fontSize: "90%",
    },
    titleArea: {
        display: "flex",
        alignContent: "center",
        justifyContent: "space-between",
        alignItems: "center",
    },
    keepLink: {
        color: "#7d7d7d",
        textDecoration: "underline",
        fontSize: "small",
        marginTop: "23px",
        cursor: "pointer",
        backgroundImage: `url(${img_save})`,
        backgroundPosition: 'left 0 bottom 1%',
        backgroundSize: '20%',
        backgroundRepeat: "no-repeat",
        padding: "0 0 0 5px",
        textDecorationThickness: "2px"
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
    },
    tabnaviMobile: {
        backgroundColor: "#fff",
        width: "100%",
        height: "57px",
        justifyContent: "center",
        display: "flex",
        borderTop:"1px solid #eee",
        borderBottom:"1px solid #c0b283"
    },
    tabnavi: {
        backgroundColor: "#fff",
        haight: "auto",
        justifyContent: "center",
        display: "flex",
        border: "1px solid #eee"
    },
    tabnavi2: {
        backgroundColor: "#fff",
        height: "60px",
        justifyContent: "center",
        display: "flex",
        borderTop: "1px solid #eee",
        borderBottom: "2px solid #c0b283"
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        margin: "8px auto 20px auto",
        width: "60%",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    searchbox: {
        width: "80%",
        margin: "0px auto",
        paddingTop: "20px",
    },
    searchboxMobile: {
        width: "90%",
        margin: "0px auto",
    },
    searchboxMobile2: {
        width: "calc(100% + 20px)",
        margin: "0px 0px 0px -10px",
    },
    errorMassage: {
        display: "inline-block",
        whiteSpace: "pre-line",
        textAlign: "center",
        padding: "15px 0px 0px 0px",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
    monthStyle: {
        fontWeight: "bold",
        fontSize: "1.5rem",
        marginLeft: "5px",
    },
    monthStyleMobile: {
        fontWeight: "bold",
        fontSize: "1rem",
        marginLeft: "5px",
    }
};

const mapStateToProps = (state) => {
    return {
        checkIn: state.checkIn,
        checkOut: state.checkOut,
        login: state.login,
        resvKaiinken: state.resvKaiinken,
        room: state.room,
        adultNum: state.adultNum,
        childNum: state.childNum,
        planConditions: state.planConditions,
        grade: state.grade,
        roomDetailCriteria: state.roomDetailCriteria,
        food: state.food,
        privilegedService: state.privilegedService,
        membershipFacility: state.membershipFacility,
        membershipSearchParam: state.membershipSearchParam,
        restaurantInfo: state.restaurantInfo,
        overnightFlg: state.overnightFlg
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setResvKaiinken: (item) => {
            dispatch({ type: "RESV_KAIINKEN", payload: { resvKaiinken: item } })
        },
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setCheckOut: (item) => {
            dispatch({ type: "CHECKOUT", payload: { checkOut: item } })
        },
        setAdultNum: (item) => {
            dispatch({ type: "ADULT_NUM", payload: { adultNum: item } })
        },
        setChildNum: (item) => {
            dispatch({ type: "CHILD_NUM", payload: { childNum: item } })
        },
        setGrade: (item) => {
            dispatch({ type: "GRADE", payload: { grade: item } })
        },
        setRoomDetailCriteria: (item) => {
            dispatch({ type: "ROOM_DETAIL_CRITERIA", payload: { roomDetailCriteria: item } })
        },
        setPlanConditions: (item) => {
            dispatch({ type: "PLAN_CONDITIONS", payload: { planConditions: item } })
        },
        setPrivilegedService: (item) => {
            dispatch({ type: "PRIVILEGED_SERVICE", payload: { privilegedService: item } })
        },
        setFood: (item) => {
            dispatch({ type: "FOOD", payload: { food: item } })
        },
        setMembershipFacility: (item) => {
            dispatch({ type: "MEMBERSHIP_FACILITY", payload: { membershipFacility: item } })
        },
        setMembershipSearchParam: (item) => {
            dispatch({ type: "MEMBERSHIP_SEARCH_PARAM", payload: { membershipSearchParam: item } })
        },
        setRestauraantInfo: (item) => {
            dispatch({ type: "RESTAURANT_INFO", payload: { restrauntInfo: item } })
        },
        setDispFacility: (item) => {
            dispatch({ type: "DISP_FACILITY", payload: { dispFacility: item } })
        },
        setDispDetailCondition: (item) => {
            dispatch({ type: "DISP_DETAIL_CONDITION", payload: { dispDetailCondition: item } })
        },
        setVacancyWeek: (weekList) => {
            dispatch({ type: "VACANCY_WEEK", payload: { vacancyWeek: weekList } });
        },
        setInputUserInfo: (item) => {
            dispatch({ type: "INPUT_USER_INFO", payload: { inputUserInfo: item } })
        },
        setOvernightFlg: (item) => {
            dispatch({ type: "OVERNIGHT_FLG", payload: { overnightFlg: item } })
        },
        setMembershipResvStartDate: (item) => {
            dispatch({ type: "MEMBERSHIP_RESV_START_DATE", payload: { membershipResvStartDate: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(MembershipSearchContainer);
